module.exports = __webpack_public_path__ + "static/media/no_result.6fd45cde.svg";